import { useState } from "react";

export function useUploadProgress() {
    const [uploadPercentage, setUploadPercentage] = useState<number>();

    // Called once per upload so a new upload starts from an empty bar instead of the last upload's 100 %
    function trackUploadProgress() {
        setUploadPercentage(undefined);
        return setUploadPercentage;
    }

    return { uploadPercentage, trackUploadProgress };
}
